var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"word_cloud section mx-3"},[_c('vue-word-cloud',{staticStyle:{"height":"480px","width":"640px","text-align":"center"},attrs:{"words":_vm.view_count,"color":function () { return this$1.colors_set[Math.floor(Math.random() * _vm.colors_set.length)]; },"font-family":"Kanit"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var text = ref.text;
var weight = ref.weight;
var word = ref.word;
return [_c('div',{staticStyle:{"cursor":"pointer"},attrs:{"title":weight},on:{"click":function($event){return _vm.onWordClick(word)}}},[_vm._v("\n        "+_vm._s(text)+"\n      ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }